(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .factory('FormEvents', FormEvents);

    function FormEvents(lodash, FormEventActions, $timeout, $rootScope) {
        return function (mem) {
            return {
                onEventTrigger: onEventTrigger,
                getEventOptions: getEventOptions,
                getModelOptions: getModelOptions,
                refreshDataOfElement: refreshDataOfElement,
                setPristine: setPristine
            };

            function onEventTrigger(type) {
                var elementViewModel = this; // through using .bind(this) in the element's Directive

                $timeout(function () {
                    var actions = lodash.get(mem.fbData, ['form_events', generateEventPath(elementViewModel.element.elementIdentifier), 'type', type, 'actions'].join('.'), false);
                    if (actions) {
                        FormEventActions(mem.formIdentifier, actions, elementViewModel.element, elementViewModel.model);
                    }

                    var allActions = lodash.get(mem.fbData, ['form_events.all.type', type, 'actions'].join('.'), false);
                    if (allActions) {
                        var exclude = lodash.get(mem.fbData, ['form_events.all.type', type, 'rules', 'exclude'].join('.'), []);
                        var is_excluded = lodash.indexOf(exclude, elementViewModel.element.name);
                        if (is_excluded == -1) {
                            FormEventActions(mem.formIdentifier, allActions, elementViewModel.element, elementViewModel.model);
                        }
                    }
                });
                if (type === 'onChange') {
                    if (lodash.get(mem, 'fbData.settings.formOnChange', '').length > 0) {
                        $rootScope.$broadcast(mem.fbData.settings.formOnChange, {
                            model: mem.fbModel
                        });
                    }
                }
            }

            function getModelOptions() {
                var elementViewModel = this; // through using .bind(this) in the element's Directive

                var modelOptions = {
                    debounce: {
                        //'default': 500
                    }
                };

                if (lodash.has(mem.fbData, ['form_events', generateEventPath(elementViewModel.element.elementIdentifier)]) || lodash.has(mem.fbData, 'all')) {
                    modelOptions = lodash.get(elementViewModel.element, 'events.options.ngModelOptions', {
                        debounce: {
                            'default': 500
                        }
                    });
                }

                if (lodash.has(elementViewModel.element, 'options.ngModelOptions')) {
                    modelOptions = angular.extend(modelOptions, elementViewModel.element.options.ngModelOptions);
                }

                return modelOptions;
            }

            function getEventOptions(elementName, type) {
                return lodash.get(mem.fbData, ['form_events', generateEventPath(elementName), 'type', type, 'options'].join('.'), {});
            }

            function generateEventPath(path) {
                return path.replace(/(\[[\w\d\s]*\])/g, '');
            }

            function refreshDataOfElement(elementName) {
                refreshData(mem.renderedElements, elementName);
            }

            function refreshData(elements, elementName) {
                angular.forEach(elements, (element) => {
                    if (!lodash.has(element, 'name')) {
                        refreshData(element, elementName);
                    } else {
                        if (element.name == elementName && lodash.has(element, 'refreshData') && (typeof element.refreshData == typeof function () {
                            })) {
                            element.refreshData();
                        }
                    }
                });
            }

            function setPristine() {
                if (mem.currentScope.form) {
                    mem.currentScope.form.$setPristine();
                    mem.currentScope.form.$setUntouched();
                }
            }
        };
    }
})();
